import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    curVideoSrc:"",
    guests: {
      // 619数据
      date19_top: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_kick_off_2.svg",
          show_time: "19:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "Rebuild 2020 开场",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_zhangpeng.png",
          identity1: "发起人",
          name1: "张  鹏",
          id1: "ID:开公园的鹏哥",
          achievement1: "极客公园",
          sub_achievement1: "创始人 & 总裁",
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "19:35",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "奇怪知识的正确打开方式",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_chenrui.png",
          identity1: "对话嘉宾",
          name1: "陈睿",
          id1: "",
          achievement1: "哔哩哔哩",
          sub_achievement1: "董事长 & CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_luoxiang.png",
          identity2: "特约up主",
          name2: "罗翔",
          id2: "ID:罗翔说刑法",
          achievement2: "bilibili 知名 UP 主、\r\n中国政法大学教授",
          vSrc:"//player.bilibili.com/player.html?aid=201030028&bvid=BV1yz411i7LV&cid=203949257&page=1",
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "20:00",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "凶悍执行，环游世界与赚钱「顶流投资人」的反转人生",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_zhangying.png",
          identity1: "对话嘉宾",
          name1: "张  颖",
          id1: "",
          achievement1: "经纬中国",
          sub_achievement1: "创始管理合伙人",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_banfou.png",
          identity2: "特约up主",
          name2: "半佛仙人",
          id2: "ID:硬核的半佛仙人",
          achievement2: "bilibili 知名科技 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=243559412&bvid=BV1Zv411q7nT&cid=203722168&page=1"
        },
      ],
      date19_bottom: [
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "20:40",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "从爱好出发！",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_suiguodong.png",
          identity1: "对话嘉宾",
          name1: "隋国栋",
          id1: "",
          achievement1: "值得买科技",
          sub_achievement1: "创始人、董事长",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_zge.png",
          identity2: "特约up主",
          name2: "Z 哥",
          id2: "ID:zettaranc",
          achievement2: "bilibili 2019 百大 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=796080178&bvid=BV1ZC4y1a7u6&cid=203582379&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "21:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "停不下来的创业与不可逆的全球化",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_zhouhang_3.png",
          identity1: "对话嘉宾",
          name1: "周航",
          id1: "",
          achievement1: "顺为资本",
          sub_achievement1: "投资合伙人",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_gaoyousi_2.png",
          identity2: "特约up主",
          name2: "高佑思",
          id2: "ID: 高佑思不是皮克",
          achievement2: "bilibili 知名 UP 主、\r\n歪果仁研究协会会长",
          vSrc:"//player.bilibili.com/player.html?aid=243548196&bvid=BV1dv411q7na&cid=203591993&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "21:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "梦想，是用来坚持的",
          themeColor: "#FF0062",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_leijun.png",
          identity1: "对话嘉宾",
          name1: "雷  军",
          id1: "",
          achievement1: "小米集团",
          sub_achievement1: "创始人、董事长 & CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_hetongxue.png",
          identity2: "特约up主",
          name2: "何同学",
          id2: "ID:老师好我叫何同学",
          achievement2: "bilibili 2019百大UP主、\r\n2019年度最佳作品奖UP主",
          vSrc:"//player.bilibili.com/player.html?aid=243562981&bvid=BV1fv411q7sg&cid=203589945&page=1"
        },
      ],
      // 620上半场数据
      date20_one_top: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "14:00",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "未来科技，想象力是最大生产力",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_shenxiangyang.png",
          identity1: "对话嘉宾",
          name1: "沈向洋博士",
          id1: "",
          achievement1: "著名科学家、学者",
          sub_achievement1: "",
          vSrc:"//player.bilibili.com/player.html?aid=541015642&bvid=BV1bi4y1x7iy&cid=203928893&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "14:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "中国最有排面的车队究竟什么样?",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_hanxu.png",
          identity1: "对话嘉宾",
          name1: "韩 旭",
          id1: "",
          achievement1: "文远知行 WeRide",
          sub_achievement1: "创始人兼 CEO",
          vSrc:"//player.bilibili.com/player.html?aid=838555966&bvid=BV1sg4y1q7hx&cid=203925176&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "14:50",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "一个智能助手践行者的内心独白",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_jingkun_2.png",
          identity1: "对话嘉宾",
          name1: "景 鲲",
          id1: "",
          achievement1: "百度",
          sub_achievement1: "百度集团副总裁、百度智能生活事业群组（SLG）总经理",
          vSrc:"//player.bilibili.com/player.html?aid=626001183&bvid=BV12t4y1X7cm&cid=203928194&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "15:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "人人在说「机器」人，我想聊聊机器「人」",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_zhoujian.png",
          identity1: "对话嘉宾",
          name1: "周剑",
          id1: "",
          achievement1: "优必选科技",
          sub_achievement1: "创始人、董事长兼 CEO",
          vSrc:"//player.bilibili.com/player.html?aid=796051008&bvid=BV1zC4y1a7J8&cid=203932178&page=1"
        },
      ],
      date20_one_bottom: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "15:40",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "「挂科」的人生，也可以「开挂」",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_wangxingxing.png",
          identity1: "对话嘉宾",
          name1: "王兴兴",
          id1: "",
          achievement1: "宇树科技",
          sub_achievement1: "创始人 & CEO & CTO",
          vSrc:"//player.bilibili.com/player.html?aid=838593528&bvid=BV1ig4y1q7e8&cid=203932775&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "16:00",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "论如何拯救熬夜脱发和啤酒肚",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_huangwang.png",
          identity1: "对话嘉宾",
          name1: "黄汪",
          id1: "",
          achievement1: "华米科技",
          sub_achievement1: "创始人 & 董事长 & CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_tubada.png",
          identity2: "特约up主",
          name2: "兔叭咯",
          id2: "ID: 兔叭咯",
          achievement2: "bilibili 知名娱乐 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=841103600&bvid=BV1f54y1B7pi&cid=203926851&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "16:20",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "终结者不会来，但你得预习有 AI 的未来",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_likaifu.png",
          identity1: "对话嘉宾",
          name1: "李开复博士",
          id1: "",
          achievement1: "创新工场",
          sub_achievement1: "董事长兼 CEO",
          vSrc:"//player.bilibili.com/player.html?aid=883620157&bvid=BV14K4y147bp&cid=203933356&page=1"
        },
      ],
      // 620下半场数据
      date20_two_top: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "19:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "脑机接口将如何改造人类?",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_hanbicheng.png",
          identity1: "对话嘉宾",
          name1: "韩璧丞",
          id1: "",
          achievement1: "BrainCo 强脑科技",
          sub_achievement1: "创始人兼 CEO",
          vSrc:"//player.bilibili.com/player.html?aid=286090663&bvid=BV1Rf4y1y7cz&cid=203919050&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "19:50",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "AI 与人类的相处之道",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_wangxiaochuan.png",
          identity1: "对话嘉宾",
          name1: "王小川",
          id1: "",
          achievement1: "搜狗",
          sub_achievement1: "创始人、CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_bidao.png",
          identity2: "特约up主",
          name2: "毕导",
          id2: "ID: 毕导THU",
          achievement2: "bilibili 知名 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=711103428&bvid=BV1JD4y1Q7tH&cid=203929704&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "20:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "向宇宙中心发射爱",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_yaobowen.png",
          identity1: "对话嘉宾",
          name1: "姚博文",
          id1: "",
          achievement1: "星际荣耀",
          sub_achievement1: "副总裁",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_bidao.png",
          identity2: "特约up主",
          name2: "毕导",
          id2: "ID: 毕导THU",
          achievement2: "bilibili 知名 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=626069242&bvid=BV1Nt4y197dc&cid=203930455&page=1"
        },
      ],
      date20_two_bottom: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "20:50",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "看穿 5G ——发现 5G 的真相",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_xuhao.png",
          identity1: "对话嘉宾",
          name1: "徐晧博士",
          id1: "",
          achievement1: "高通公司",
          sub_achievement1: "中国区研发负责人",
          vSrc:"//player.bilibili.com/player.html?aid=796085583&bvid=BV1UC4y1a7pq&cid=203931423&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "21:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "你看不见的数字化世界，安全应该摆在哪儿?",
          themeColor: "#0023FC",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_zhouhongyi.png",
          identity1: "对话嘉宾",
          name1: "周鸿祎",
          id1: "",
          achievement1: "360集团",
          sub_achievement1: "董事长 兼 CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_linchao.png",
          identity2: "特约up主",
          name2: "林超",
          id2: "ID:  所长林超",
          achievement2: "bilibili 知名科普 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=668616407&bvid=BV1Ba4y1Y7bS&cid=204029535&page=1"
        },
      ],
      // 621上半场数据
      date21_one_top: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/musice_img.svg",
          show_time: "14:00",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "原创音乐展演 +\r\n 直播间互动抽奖",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_geek_choose.png",
          identity1: "",
          name1: "极客之选",
          id1: "",
          achievement1: "",
          sub_achievement1: "",
          vSrc:""
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "14:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "在「一个人就是一家公司」的时代行动起来",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_huxiaoming.png",
          identity1: "对话嘉宾",
          name1: "胡晓明",
          id1: "",
          achievement1: "蚂蚁集团",
          sub_achievement1: "CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_laojiang.png",
          identity2: "特约up主",
          name2: "老蒋",
          id2: "ID:老蒋巨靠谱",
          achievement2: "bilibili 知名科普 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=668564226&bvid=BV1Ha4y1Y78A&cid=204341811&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "15:00",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "枯燥老板背后，到底是不羁，还是坚持",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_hexiaopeng.png",
          identity1: "对话嘉宾",
          name1: "何小鹏",
          id1: "",
          achievement1: "小鹏汽车",
          sub_achievement1: "CEO",
          vSrc:"//player.bilibili.com/player.html?aid=668541159&bvid=BV1xa4y1Y7bj&cid=204341977&page=1"
        },
      ],
      date21_one_bottom: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "15:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "你吃的不是外卖，是 AI",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_xiahuaxia.png",
          identity1: "对话嘉宾",
          name1: "夏华夏",
          id1: "",
          achievement1: "美团",
          sub_achievement1: "美团首席科学家、AI平台部总经理",
          vSrc:"//player.bilibili.com/player.html?aid=583575339&bvid=BV1Sz4y1Q7sS&cid=204330970&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "15:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "5G 出圈——银河系最强的中国 5G 如何跨界生长",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_gujia_2.png",
          identity1: "对话嘉宾",
          name1: "顾嘉",
          id1: "",
          achievement1: "华为",
          sub_achievement1: "中国运营商市场洞察部部长",
          vSrc:"//player.bilibili.com/player.html?aid=841071528&bvid=BV1U54y1B79T&cid=204342004&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "16:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "摆脱脏乱差，居住服务如何大变样?",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_pengyongdong.png",
          identity1: "对话嘉宾",
          name1: "彭永东",
          id1: "",
          achievement1: "贝壳找房",
          sub_achievement1: "CEO",
          vSrc:"//player.bilibili.com/player.html?aid=583583028&bvid=BV1rz4y1Q7ZL&cid=204319137&page=1"
        },
      ],
      // 621下半场数据
      date21_two_top: [
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/musice_img.svg",
          show_time: "19:15",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "好听到停不下来的原创作品展演",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_shii.png",
          identity1: "表演嘉宾",
          name1: "Shii",
          id1: "",
          achievement1: "美丽音乐",
          sub_achievement1: "独立电子音乐人",
          vSrc:""
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "19:30",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "6 年——从实习生到 CEO",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_shenpeng_2.png",
          identity1: "对话嘉宾",
          name1: "沈鹏",
          id1: "",
          achievement1: "水滴公司",
          sub_achievement1: "创始人 & CEO",
          vSrc:"//player.bilibili.com/player.html?aid=243621640&bvid=BV1jv411B7ni&cid=204331945&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_key_talk.svg",
          show_time: "19:50",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "大疆、逸动、云鲸……学院派创业者们背后的故事",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_lizexiang.png",
          identity1: "对话嘉宾",
          name1: "李泽湘教授",
          id1: "",
          achievement1: "松山湖机器人产业基地",
          sub_achievement1: "创始人",
          vSrc:"//player.bilibili.com/player.html?aid=626024158&bvid=BV1rt4y1X72y&cid=204344839&page=1"
        },
        {
          type: "one",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "21:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow1.png",
          slogan: "解密汽车行业，如何面对不确定性?",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_libin.png",
          identity1: "对话嘉宾",
          name1: "李 斌",
          id1: "",
          achievement1: "蔚来",
          sub_achievement1: "创始人、董事长、CEO",
          vSrc:"//player.bilibili.com/player.html?aid=883586581&bvid=BV17K4y147TP&cid=204344879&page=1"
        },
      ],
      date21_two_bottom: [
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "20:40",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow2.png",
          slogan: "为什么越来越多的年轻人开始拥抱潮流?",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_yangbin.png",
          identity1: "对话嘉宾",
          name1: "杨 冰",
          id1: "",
          achievement1: "得物 App",
          sub_achievement1: "创始人兼 CEO",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_chonglang.png",
          identity2: "特约up主",
          name2: "冲浪普拉斯",
          id2: "ID:冲浪普拉斯",
          achievement2: "bilibili 知名科普 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=668562256&bvid=BV1pa4y1Y7Nc&cid=204323399&page=1"
        },
        {
          type: "two",
          title: "https://summit-img.geekpark.net/r2020/pc_pengyoushuo.svg",
          show_time: "21:10",
          rightArrow: "https://summit-img.geekpark.net/r2020/pc_geust_right_arrow3.svg",
          slogan: "人生爬坑指南",
          themeColor: "#00D2B2",
          avatar1: "https://summit-img.geekpark.net/r2020/guest_luoyonghao.png",
          identity1: "对话嘉宾",
          name1: "罗永浩",
          id1: "",
          achievement1: "交个朋友科技",
          sub_achievement1: "首席推荐官",
          avatar2: "https://summit-img.geekpark.net/r2020/guest_yingshijufeng.png",
          identity2: "特约up主",
          name2: "影视飓风",
          id2: "ID:影视飓风",
          achievement2: "bilibili 2019 百大 UP 主",
          vSrc:"//player.bilibili.com/player.html?aid=456099429&bvid=BV1R5411W7zd&cid=204323350&page=1"
        },
      ],
    },
  },
  mutations: {
    handleVSrcToggle(state,curVideoSrc){
      state.curVideoSrc = curVideoSrc
    }
  },
  actions: {},
  modules: {},
});
